module.exports = __webpack_public_path__ + "static/left-floating-land-d28136ddf9b14f68e586bf53ae42410f.svg";